import { useMemo } from 'react';

import { GiftPassBundleApiError } from '../../api/gift-pass-bundles';
import { useListFilterParams } from '../../hooks/use-list-filter-params';

import {
  ALL_BUNDLES,
  BUNDLE_LIST_TABS,
  countBundlesByTab,
  visibleBundles,
} from './gift-pass-bundles-list-model';
import { useAllGiftPassBundles } from './use-gift-pass-bundles';

export function useGiftPassBundlesListView() {
  const params = useListFilterParams(BUNDLE_LIST_TABS, ALL_BUNDLES);
  const query = useAllGiftPassBundles();
  const { tab, search } = params;

  const all = query.data?.bundles;
  const counts = useMemo(() => countBundlesByTab(all ?? []), [all]);
  const rows = useMemo(() => visibleBundles(all ?? [], tab, search), [all, tab, search]);
  const loaded = query.data !== undefined;
  // A failed background refresh keeps the list it already has; a retry shows progress.
  const error = loaded || query.isFetching ? null : query.error;

  return {
    ...params,
    counts,
    rows,
    pricing: query.data?.pricing ?? null,
    loaded,
    loading: !loaded && (query.isPending || query.isFetching),
    failure: !error
      ? null
      : error instanceof GiftPassBundleApiError && error.status === 403
        ? ('forbidden' as const)
        : ('failed' as const),
    retry: () => void query.refetch(),
  };
}
